// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.full-height {\n  position: relative;\n  height: 100%;\n}\n.el-dialog__body {\n  padding-top: 0px;\n}\n.no-tax-price {\n  font-size: 17px;\n  color: blue;\n  font-weight: bold;\n}\n.tax-price {\n  font-size: 17px;\n  color: green;\n  font-weight: bold;\n}\n.accountsPayableManagement-app-container div.el-dialog__body {\n  position: relative;\n  height: 86%;\n}\n", ""]);
// Exports
module.exports = exports;
